import React, { useState, useEffect } from "react"
import CustomButton from "../Atoms/CustomButton"
import CustomDialog from "../Atoms/CustomDialog"
import FormController from "../Molecules/FormController"
import { set, cloneDeep } from "lodash-es"

type ReportDialogProps = {
  isOpen: boolean
  title?: string
  onClose: () => void
  onClick: (data: any) => void
  text?: string
  defaultData?: any
  children?: React.ReactNode
}
const ReportDialog = ({
  isOpen,
  onClose,
  onClick,
  text = "Report",
  title = "Module",
  children,
  defaultData,
}: ReportDialogProps) => {
  const [data, changeData] = useState({ ...defaultData })
  useEffect(() => {
    changeData({ ...defaultData })
  }, [defaultData])
  function handleChange(path, value) {
    const dataCopy = cloneDeep(data)
    set(dataCopy, path, value)
    changeData(dataCopy)
  }
  return (
    <CustomDialog
      light
      icon="document"
      title={
        <>
          <span className="vt-muted">Report - </span>
          <span className="vt-highlight">{title}</span>
        </>
      }
      isOpen={isOpen}
      onClose={onClose}
      footerRightButton={
        <CustomButton dark icon="download" onClick={e => onClick(data)}>
          {text}
        </CustomButton>
      }
    >
      <FormController source={data} onChange={handleChange}>
        {children}
      </FormController>
    </CustomDialog>
  )
}

export default ReportDialog
